import { render, staticRenderFns } from "./AttachmentTypologyTable.vue?vue&type=template&id=316b442c&"
import script from "./AttachmentTypologyTable.vue?vue&type=script&lang=js&"
export * from "./AttachmentTypologyTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports